import { formatInTimeZone } from 'date-fns-tz';

export default class ZonedDateRange {
    private _start: Date | null;

    private _end: Date | null;

    private _timezoneInHours: number | null;

    private readonly dateMask: string;

    constructor(dateMask: string = 'yyyy-MM-dd') {
        this._start = null;
        this._end = null;
        this._timezoneInHours = null;
        this.dateMask = dateMask;
    }

    public getFormattedStart(): string | null {
        return this.getFormattedDate(this._start);
    }

    public getFormattedEnd(): string | null {
        return this.getFormattedDate(this._end);
    }

    public setRange(start: Date, end: Date): void {
        this._start = start;
        this._end = end;
    }

    public clone(): ZonedDateRange {
        const clonedDateRangeOutput = new ZonedDateRange(this.dateMask);
        if (this._start !== null) {
            clonedDateRangeOutput.start = this._start;
        }
        if (this._end !== null) {
            clonedDateRangeOutput.end = this._end;
        }
        if (this._timezoneInHours !== null) {
            clonedDateRangeOutput.timezoneInHours = this._timezoneInHours;
        }
        return clonedDateRangeOutput;
    }

    get start(): Date | null {
        return this._start;
    }

    set start(value: Date) {
        this._start = value;
    }

    get end(): Date | null {
        return this._end;
    }

    set end(value: Date) {
        this._end = value;
    }

    get timezoneInHours(): number | null {
        return this._timezoneInHours;
    }

    set timezoneInHours(value: number) {
        this._timezoneInHours = value;
    }

    private getFormattedDate(date: Date | null): string | null {
        if (date === null) {
            return null;
        }
        return formatInTimeZone(date, 'UTC', this.dateMask);
    }
}
